import ButtonLoader from '@anm/components/buttons/ButtonLoader';
import { FC } from 'react';
import styled from 'styled-components';

import useStaffDuplicate from './hooks/useStaffDuplicate';

type StaffDuplicateProps = {
  projectId: string;
};

const ButtonWrapper = styled(ButtonLoader)`
  margin-right: 10px;
`;

const StaffDuplicate: FC<StaffDuplicateProps> = ({ projectId }) => {
  const [isPending, canDuplicate, handleDuplicate] = useStaffDuplicate(
    projectId
  );

  if (!canDuplicate) return null;

  return (
    <ButtonWrapper
      size="big"
      color="blue"
      variant="white-blue-border-share"
      onClick={handleDuplicate}
      {...{ isPending }}
    >
      Duplicate
    </ButtonWrapper>
  );
};

export default StaffDuplicate;
